import { Box, styled } from '@mui/material';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';

const MainContent = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.default,
  minHeight: '100vh',
}));

const Layout = () => {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar />
      <MainContent>
        <Outlet />
      </MainContent>
    </Box>
  );
};

export default Layout; 